import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const signinPusher = (socket_id: string) => {
  return useApi(http.post(`pusher/auth`, { socket_id }))
}
